import { Controller } from "@hotwired/stimulus";

// One brand color row. A hidden field carries the submitted value ("" = unset, which Nexus reads as
// "clear this color") because a native color picker can never be empty. The invisible picker overlays
// the swatch area: picking a color fills the hidden field and swaps the dashed "Select color" empty
// state for a filled swatch; Clear empties the field and swaps back.
export default class extends Controller {
  static targets = ["field", "picker", "swatch", "empty", "clear"];

  pick() {
    const color = this.pickerTarget.value;
    this.fieldTarget.value = color;
    this.swatchTarget.style.backgroundColor = color;
    this.#toggleSelected(true);
  }

  clear() {
    this.fieldTarget.value = "";
    this.#toggleSelected(false);
    // The form's unsaved-changes tracker listens for input events, and setting a value from JS
    // doesn't fire one.
    this.fieldTarget.dispatchEvent(new Event("input", { bubbles: true }));
  }

  #toggleSelected(selected) {
    this.swatchTarget.classList.toggle("hidden", !selected);
    this.emptyTarget.classList.toggle("hidden", selected);
    this.clearTarget.classList.toggle("hidden", !selected);
  }
}
